export const isObject = (x: unknown): x is { [key: string]: any } =>
  Object.prototype.toString.call(x) === '[object Object]'
